export enum ToastType {
	ERROR,
	INFORMATIONAL,
}

export interface ToastModel {
	message: string,
	type: ToastType
}